<template>
<div class="full-width">

  <div class="relative video-relative">
    <video ref="video"
           class="screen full-width"
           :poster="!loaded ? require('@/assets/img/exercicies/words-attack/intro.png') : ''"
           :src="exercise.video"
           @playing="isPlaying = true"
           @pause="isPlaying = false"
           @loadeddata="loadedData($event.target)"
           @timeupdate="showInterruptions($event.target)" />
    <div class="play-btn" v-if="firstTime">
      <div class="play-btn__img"
           :style="{ cursor: loaded ? 'pointer' : 'not-allowed' }">
        <img src="@/assets/img/video-play.svg"
             :style="{ zIndex: loaded ? '10' : '0' }"
             @click="play()">
      </div>
    </div>
    <Answers :exercise="exercise" :question="question" :feedback="feedback" :showInfo="showModal"/>
  </div>

  <div class="container align-items-center justify-content-end">
    <div class="margin-right-10 animation-fade">
      <transition name="fade">
        <gameFeedback :correct="question.hit" v-show="showFeedback"/>
      </transition>
      <div v-if="question.hit && question.answered" class="animation-bottom animation-delay-15 bottom-alert">
        <span class="correct_result">
          <i class="far fa-check-circle"></i>
          Alternativa correta</span>
      </div>
      <div v-if="!question.hit && question.answered" class="animation-bottom animation-delay-15 bottom-alert">
        <span class="wrong_result">
          <i class="far fa-times-circle"></i>
          Alternativa incorreta</span>
      </div>
    </div>
  </div>
  <modal ref="modal" v-if="!isReview" :show="showInfo" :closebtn="false" bgcolor="rgba(243, 243, 243, .95)">
    <modalSubTopic :questions="exercise.questions" :topic="topic" :subTopic="subTopic" :close="emitClose"/>
  </modal>
</div>
</template>
<script>
import { mapGetters } from 'vuex'
import gameFeedback from "@/components/game/feedback";
import modal from "@/components/modal";
import modalBus from "@/components/modal/modalBus";
import modalSubTopic from "@/components/modal/modalSubTopic";
import gameBus from '@/components/game/gameBus'
import answerBus from './GameComponents/Answers/bus'
import Answers from './GameComponents/Answers'

export default {
  name: "InteractiveVideo",
  components: {
    Answers,
    gameFeedback,
    modal,
    modalSubTopic
  },
  data() {
    return {
      question: {},
      duration: 0,
      volume: 1,
      isPlaying: false,
      loaded: false,
      interruption: null,
      time: {
        old: 0,
        current: 0
      },
      index: -1,
      ended: false,
      showInfo: false,
      showFeedback: false,
      firstTime: true
    }
  },
  computed: {
    ...mapGetters({
      isReview: "isReview",
    }),
    exercise () {
      return this.subTopic.exercise
    }
  },
  props: {
    subTopic: {
      type: Object,
      default: () => ({})
    },
    topic: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    setCurrent () {
      let qst = {},
          currentIndex = 0
      const questions = this.exercise.questions.sort((a, b) => a.time - b.time)
      for (const index in questions) {
        currentIndex = index
        if (!questions[index].answered) {
          qst = questions[index]
          break
        } else if (index == (questions.length - 1)) {
          qst = questions[index]
          this.ended = true
        }
      }
      this.index = currentIndex
      if (Object.keys(this.question).length == 0 || qst._id !== this.question._id) {
        if (!qst.answered) qst.answers = this.$shuffle(qst.answers)
        this.$set(this, 'question', qst)
      }

      setTimeout(() => {
        gameBus.$emit("setEnabled", this.question.answered);
      }, 1000)
    },
    play () {
      if (this.loaded) {
        if (this.firstTime) {
          this.firstTime = false
        } else {
          this.setCurrent()
        }
        this.$refs['video'].play()
      }
    },
    pause () {
      this.$refs['video'].pause()
    },
    loadedData (video) {
      this.duration = video.duration
      this.loaded = true
      this.firstTime = true
      // video.play()
    },
    showInterruptions (video) {
      this.time.old = this.time.current
      this.time.current = video.currentTime
      if (this.question.time) {
        if (this.question.time >= this.time.old && this.question.time <= this.time.current) {
          answerBus.$emit('show')
          video.pause()
        }
      }
    },
    viewQuestion (index) {
      const question = this.exercise.questions[index]
      if (question && question.answered) {
        this.index = index
        this.firstTime = false
        this.$set(this, 'question', question)
        this.question.answers = this.$shuffle(this.question.answers)
        this.pause()
        this.$refs['video'].currentTime = question.time
        answerBus.$emit('show')
      }
    },
    async feedback () {
      this.showFeedback = true
      await this.$delay(1500)
      this.showFeedback = false
      gameBus.$emit('setEnabled', true)
    },
    emitClose () {
      this.$refs['modal'].close()
    },
    closeModal () {
      this.showInfo = false
    },
    showModal () {
      this.showInfo = true
    }
  },
  watch: {
    ended (val) {
      gameBus.$emit('setEnded', val)
    },
    index (val) {
      gameBus.$emit('updateIndex', val)
    },
    'exercise.video' () {
      this.$refs['video'].pause()
      this.$refs['video'].load()
    }
  },
  async mounted() {
    answerBus.$on('play', this.play)
    this.setCurrent()
    gameBus.$on('viewQuestion', this.viewQuestion)

    gameBus.$emit('updateProgress', this.subTopic.points)
    modalBus.$off('close', this.closeModal)
    gameBus.$on('setCurrent', this.play)
  },
  beforeDestroy() {
    answerBus.$off('play', this.play)
    gameBus.$off('viewQuestion', this.viewQuestion)

    modalBus.$off('close', this.closeModal)
    gameBus.$off('setCurrent', this.play)
  }
}
</script>
<style lang="scss" scoped>
@import './src/assets/css/base/variables';

.video-relative {
  position: relative;
  border-radius: 4px;
  overflow: hidden;
}

.play-btn {
  width: 100%;
  height: 100%;
  display: flex;
  position: absolute;
  background-color: rgba(0, 0, 0, .625);
  top: 0;
  left: 0;
  &__img {
    display: inline-block;
    margin: auto;
    img {
      position: relative;
      transition: all .2s;
    }
    &::before {
      content: '';
      display: block;
      position: absolute;
      background-color: rgba(255, 255, 255, .25);
      width: 104px;
      height: 105px;
      top: calc(50% - 52.5px);
      left: calc(50% - 52px);
      border-radius: 150px;
      z-index: 5;
      transition: all .2s;
    }
    &:hover {
      img {
        transform: scale(1.4);
      }
      &::before {
        transform: scale(1.25);
      }
    }
  }
}

.finish-btn {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}

.correct_result,
.wrong_result {
  font-weight: bold;
}

.correct_result {
  color: $color-green !important;
}

.wrong_result {
  color: $color-red !important;
}
</style>



// WEBPACK FOOTER //
// src/components/game/interactiveVideoGame.vue